var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: -2,
    width: 47.8701,
    height: 47.8701,
    rx: 5,
    transform: "rotate(45 32 -2)",
    fill: "#C3645E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 22C29.1446 22.0001 27.8089 22.3244 26.6043 22.9457C25.3996 23.567 24.3611 24.4674 23.5752 25.5718C22.7894 26.6761 22.279 27.9523 22.0867 29.294C21.8944 30.6357 22.0257 32.004 22.4698 33.2846C22.9138 34.5652 23.6576 35.7211 24.6392 36.6557C25.6208 37.5904 26.8117 38.2768 28.1125 38.6576C29.4133 39.0384 30.7863 39.1026 32.117 38.8449C33.4477 38.5872 34.6974 38.015 35.762 37.176L39.414 40.828C39.6026 41.0102 39.8552 41.111 40.1174 41.1087C40.3796 41.1064 40.6304 41.0012 40.8158 40.8158C41.0012 40.6304 41.1064 40.3796 41.1087 40.1174C41.1109 39.8552 41.0102 39.6026 40.828 39.414L37.176 35.762C38.164 34.5086 38.7792 33.0024 38.9511 31.4157C39.123 29.8291 38.8448 28.226 38.1482 26.7901C37.4516 25.3542 36.3649 24.1434 35.0123 23.2962C33.6597 22.4491 32.096 21.9999 30.5 22ZM24 30.5C24 28.7761 24.6848 27.1228 25.9038 25.9038C27.1228 24.6848 28.7761 24 30.5 24C32.2239 24 33.8772 24.6848 35.0962 25.9038C36.3152 27.1228 37 28.7761 37 30.5C37 32.2239 36.3152 33.8772 35.0962 35.0962C33.8772 36.3152 32.2239 37 30.5 37C28.7761 37 27.1228 36.3152 25.9038 35.0962C24.6848 33.8772 24 32.2239 24 30.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMobile);
export default __webpack_public_path__ + "static/media/search-mobile.da05ac316df45aa594e3f9aff268ca38.svg";
export { ForwardRef as ReactComponent };